import { __commonJSMin as e } from "./index2.js";
import { require_react_jsx_runtime_production as t } from "./index18.js";
import { require_react_jsx_runtime_development as n } from "./index20.js";
//#region ../../node_modules/.pnpm/react@19.2.4/node_modules/react/jsx-runtime.js
var r = /* @__PURE__ */ e(((e, r) => {
	process.env.NODE_ENV === "production" ? r.exports = t() : r.exports = n();
}));
//#endregion
export default r();
export { r as require_jsx_runtime };

//# sourceMappingURL=index21.js.map